import { getCategoryHref } from '../../utils/common/category';
import { LANDING_PAGE_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'landingPageTitleGeneratorType',
      analyticsName: 'landingPage_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: LANDING_PAGE_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'LandingPage',
        value: getCategoryHref(LANDING_PAGE_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'landingPageTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'landingPage_titles_generator',
      placeholder: 'Try "marketing SaaS video solution for SMBs"',
      textLabel: 'Describe the landing page’s topic',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: LANDING_PAGE_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
